
function App(props) {

  var width = props.width;
  var textList = props.textList;

  var txt = textList.map((aC, index)=>{
              return <div key={index}>{aC}</div>
            })
//

    return <div style={{padding:'10px', width}}>
      {txt}
      </div>

}

export default App;
